module.exports = __webpack_public_path__ + "img/myhouse.0c03371.png";